export const filterProductsByLatestYear = (data) => {
  if (!data) {
    return [];
  }

  const lastYear = Math.max(
    ...data.flatMap(product => product.itemProductConverts?.map(item => item.year))
  );

  return data
    .map(product => ({
      ...product,
      lastYear,
      itemProductConverts: product.itemProductConverts?.filter(item => item.year === lastYear)
    }))
    .filter(product => product.itemProductConverts?.length > 0);
};